__turbopack_context__.v({
  "arrow": "cR8Axq_arrow",
  "buttonWrap": "cR8Axq_buttonWrap",
  "empty": "cR8Axq_empty",
  "filterRow": "cR8Axq_filterRow",
  "grid": "cR8Axq_grid",
  "headBlock": "cR8Axq_headBlock",
  "heading": "cR8Axq_heading",
  "inner": "cR8Axq_inner",
  "pageBtn": "cR8Axq_pageBtn",
  "section": "cR8Axq_section",
});
